import React, { useContext, useEffect } from "react";
import "./Game_History.css";
import Common_white_header from "../Common/Common_Component/Common_white_header/Common_white_header";
import Game_History_card from "./Game_History_card/Game_History_card";
import No_data from "../Common/No_data/No_data";
import { useDispatch, useSelector } from "react-redux";
import { Context } from "../../utils/context";
import { formatAmount, formatNotifDate } from "../../utils/common";
import { GetAllHistory } from "../../features/games/color_prediction/Slice";
import CustomPagination from "../Common/Common_Component/CustomPagination/CustomPagination";

function Game_History() {


  const dispatch = useDispatch();
  const { signin } = useContext(Context)

  const gameHistory = useSelector((state) => state.games.color_prediction);




  const fetch = async (page) => {
    await dispatch(GetAllHistory({ page, }));
  };

  useEffect(() => {
    if (signin)
      fetch(1);
  }, [dispatch, signin]);


  const handlePageChange = async (page) => {
    fetch(page)
  };

  return (
    <section className="Game_History">

      <Common_white_header headingText={"Game History"} />

      <div className="container">

        {gameHistory?.Game_data?.length > 0 ?
          gameHistory?.Game_data?.map((item, index) => (
            <Game_History_card key={index}
              game={item?.Period?.Game?.name || ""}
              resultClass={item?.result === "win" ? item?.result : "lose"}
              result={item?.result === "win" ? "Win" : "Lose"}
              time={(formatNotifDate(item?.createdAt))}
              type={`Win Go ${item?.Period?.Game_Play_Time?.time}`}
              totalBet={formatAmount(item?.amount)}
              period={item?.Period?.period}
              actualAmount={formatAmount(item?.amount)}
              select={item?.color || item?.number || item?.size || "N/A"}
              periodResult={item?.Period?.Number_Result}
              ballImage={item?.ballImage}
              winnings={formatAmount(item?.profit)}
              profitClass={item?.result === "win" ? "win" : "loss"}
              profit={item?.profit}
              loss={item?.loss}
              fee={formatAmount(item?.platform_fee)}

              data={item} />
          )) : <No_data />
        }
        {gameHistory?.history_pagination?.total_pages > 1 &&
          <CustomPagination currentPage={gameHistory?.history_pagination?.current_page}
            totalPages={gameHistory?.history_pagination?.total_pages}
            handlePageChange={handlePageChange} />}
      </div>

    </section>
  );
}

export default Game_History;